import React, { useEffect, useState } from 'react';
import RootStore from '../../Store';
import AuthStack from './AuthStack';
import * as Font from 'expo-font';
import { NavigationContainer } from '@react-navigation/native';
import { ActivityIndicator, View } from 'react-native';
import { observer } from 'mobx-react-lite';
import AppStack from './AppStack';
import AsyncStorage from '@react-native-async-storage/async-storage';


const { userInfo } = RootStore.getInstance()

export const Navigation = () => {
  const [isLoadingInfo, setLoadingInfo] = useState(true);

  const isLoggedIn = userInfo.isLoggedIn;

  const LoasUserInfo = async () => {
    try {
      const token: string | null = await AsyncStorage.getItem("LoginToken")
      if (token) {
        userInfo.login(token)
      }
    } catch (err) {
      console.log(err);
      setLoadingInfo(false);
    } finally {
      setLoadingInfo(false);
    }
  };

  useEffect(() => {
    LoasUserInfo()
  }, [])

  if (isLoadingInfo) {
    return (
      <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
        <ActivityIndicator color="#D71D9A" />
      </View>
    );
  } else {
    return (
      <NavigationContainer>
        {isLoggedIn ? <AppStack /> : <AuthStack />}
      </NavigationContainer>
    );
  }
}

export default observer(Navigation);